export default "__VITE_ASSET__COhQGzaX__"